import React, { Component } from 'react'
import { Nav, NavItem } from "react-bootstrap"
import { connect } from 'react-redux'
import PropTypes from "prop-types"

import Agenda from './Agenda.jsx'
import isObjectEqual from '../../lib/isObjectEqual.js'
import { createBlockFromRoute, createBlockFromAgenda } from '../ducks/blocks'

import { getText } from '../lib/text.js'

function getCitiesList(route) {
  return route.filter(x => x.type == "city").map(x => x.city)
}

/**
 *
 */

//~ cloneRouteToTemplate = {(name, r) => this.props.cloneRouteToTemplate(name, r)}
//~ cloneSelectionToTemplate = {(name, agenda) => this.props.cloneSelectionToTemplate(name, agenda)}

/**
 * RouteEditor
 */
class RouteEditor extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      tab: "route",
    }
  }

  render() {
    const id = this.props.id
    const rid = this.props.route._id

    return (
      <div>
        <Agenda
          route={this.props.route}
          startDate={this.props.startDate}

          Activities={this.props.Activities}
          Routes={this.props.Routes}
          blockTemplatesList={this.props.blockTemplatesList}
          AliveActivitiesList={this.props.AliveActivitiesList}
          ExpensesList={this.props.ExpensesList}
          CitiesList={this.props.CitiesList}

          addActivity={(a, i) => this.props.addActivity(rid, a, i)}
          addBlock={(b, i) => this.props.addBlock(rid, b, i)}
          addNote={(i) => this.props.addNote(rid, i)}
          addCity={(city, i) => this.props.addCity(rid, city, i)}
          addDay={i => this.props.addDay(rid, i)}
          addExpense={(x, i) => this.props.addExpense(rid, x, i)}
          editItem={(i, k, v) => this.props.editItem(rid, i, k, v)}

          move={(i, dir) => this.props.move(rid, i, dir)}
          multiMove={(ii, dir) => this.props.multiMove(rid, ii, dir)}
          remove={(i, flag) => this.props.remove(rid, i, flag)}
          replaceWithBlock={b => this.props.replaceWithBlock(rid, b)}
          repeatExpense={(isrc, idst) => this.props.repeatExpense(rid, isrc, idst)}
          moveItem={(itarget, newPos) => this.props.moveItem(rid, itarget, newPos)}

          cloneRouteToTemplate={(name, r) => this.props.cloneRouteToTemplate(name, r)}
          cloneSelectionToTemplate={(name, agenda) => this.props.cloneSelectionToTemplate(name, agenda)}

          top={this.props.top}
          language={this.props.language}
          onChange={expenses => this.props.updateExpenses(rid, expenses)}
          trip={this.props.trip}
          pGestion={this.props.pGestion}
          useForcedPrice={this.props.useForcedPrice}

          isTemplate={!!this.props.isTemplate}
        />
      </div>
    )
  }
}

RouteEditor.propTypes = {
  id: PropTypes.string.isRequired,
  route: PropTypes.object.isRequired,

  Activities: PropTypes.object.isRequired,
  Routes: PropTypes.object.isRequired,
  AliveActivitiesList: PropTypes.arrayOf(PropTypes.object).isRequired,
  ExpensesList: PropTypes.arrayOf(PropTypes.object).isRequired,
  CitiesList: PropTypes.arrayOf(PropTypes.string).isRequired,
  blockTemplatesList: PropTypes.arrayOf(PropTypes.object).isRequired,

  move: PropTypes.func.isRequired,
  multiMove: PropTypes.func.isRequired,
  addActivity: PropTypes.func.isRequired,
  addCity: PropTypes.func.isRequired,
  addDay: PropTypes.func.isRequired,
  addBlock: PropTypes.func.isRequired,
  addExpense: PropTypes.func.isRequired,
  addNote: PropTypes.func.isRequired,
  editItem: PropTypes.func.isRequired,
  updateExpenses: PropTypes.func.isRequired,
  remove: PropTypes.func.isRequired,
  createBlock: PropTypes.func.isRequired,
  repeatExpense: PropTypes.func.isRequired,
  moveItem: PropTypes.func.isRequired,

  replaceWithBlock: PropTypes.func.isRequired,

  startDate: PropTypes.string, // should be required if !isTemplate, right?
  top: PropTypes.number,
  isTemplate: PropTypes.bool
}

RouteEditor.defaultProps = {
  top: 0,
  isTemplate: false,
}

const mapStateToProps = state => ({
  language: state.ui.language
})

const mapDispatchToProps = dispatch => ({
  cloneRouteToTemplate: (name: string, route: string) => dispatch(createBlockFromRoute({ name }, null, route)),
  cloneSelectionToTemplate: (name, agenda) => dispatch(createBlockFromAgenda({ name }, null, agenda))
})

export default connect(mapStateToProps, mapDispatchToProps)(RouteEditor)
